import { ISbStoryData, SbBlokData } from 'gatsby-source-storyblok';
import { environment } from '../../environment';
import { IArticle } from '../components';

export function getArticleBlokFromPageStory(story: ISbStoryData): IArticle {
  const articleBlok = story.content.body.find(
    (b: SbBlokData) => b.component === environment.storyblokArticleComponentType
  );

  return { ...articleBlok, full_slug: story.full_slug, created_at: story.created_at };
}
